import http from "e6-base-core/axios/config";

import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const { host, E6_MS_TMS_FINANCIAL_WEB } = e6ModuleSettleAccountsCenterApi;

// ------------------------ 送货员津贴 ------------------------

// 新增送货员津贴
export function saveDeliverymanAllowance(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/saveDelivery`,
    method: "post",
    data
  });
}

// 修改送货员津贴
export function updateDeliverymanAllowance(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/updateDelivery`,
    method: "post",
    data
  });
}

// 详情送货员津贴
export function getDeliverymanAllowanceById(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/getDeliveryById`,
    method: "get",
    params
  });
}

// 修改详情送货员津贴
export function editDeliverymanAllowanceInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/editDeliveryInfo`,
    method: "post",
    data
  });
}

// 获取送货员津贴列表
export function listDeliverymanAllowanceByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/listDeliveryByPage`,
    method: "post",
    data
  });
}

// 获取送货员津贴更改历史列表
export function listDeliverymanAllowanceHistoryByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/listDeliveryHistoryByPage`,
    method: "post",
    data
  });
}

// 津贴规则编码的校验
export function checkDeliverymanAllowanceCode(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/checkDeliveryCode`,
    method: "post",
    data
  });
}

// 津贴规则名称的校验
export function checkDeliverymanAllowanceName(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/checkDeliveryName`,
    method: "post",
    data
  });
}

// 删除送货员津贴列表
export function deleteDeliverymanAllowances(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/deleteDelivery`,
    method: "post",
    data
  });
}

// 查询详情
export function getDeliverymanDetail(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/delivery/getDeliveryById`,
    method: "get",
    params
  });
}
